import { requestJson } from "../api/apiClient";

const ADMIN_BASE = "/api/admin/automotive";

function buildQs(params) {
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== "");
  if (!entries.length) return "";
  return `?${new URLSearchParams(Object.fromEntries(entries)).toString()}`;
}

export function fetchInventoryQualityDashboard(params = {}) {
  return requestJson(`${ADMIN_BASE}/inventory-quality${buildQs(params)}`);
}

export function fetchInventoryQualityQueue(queue, params = {}) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/${queue}${buildQs(params)}`);
}

export function fetchInventoryQualityRules() {
  return requestJson(`${ADMIN_BASE}/inventory-quality/rules`);
}

export function recalculateInventoryQuality(payload = {}) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/recalculate`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function createInventoryFollowUp(payload) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/follow-ups`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function resolveInventoryFollowUp(followUpId, status) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/follow-ups/${encodeURIComponent(followUpId)}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}

export function confirmInventoryListingAvailable(listingId) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/listings/${encodeURIComponent(listingId)}/confirm`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function requestInventoryListingConfirmation(listingId) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/listings/${encodeURIComponent(listingId)}/request-confirmation`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function resolveDuplicateCandidate(candidateId, resolution) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/duplicates/${encodeURIComponent(candidateId)}/resolve`, {
    method: "POST",
    body: JSON.stringify({ resolution }),
  });
}

export function resolveOutlierFlag(flagId, status) {
  return requestJson(`${ADMIN_BASE}/inventory-quality/outliers/${encodeURIComponent(flagId)}/resolve`, {
    method: "POST",
    body: JSON.stringify({ status }),
  });
}

export function syncDuplicateCandidates() {
  return requestJson(`${ADMIN_BASE}/inventory-quality/duplicates/sync`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function bulkConfirmDealerListings(dealerId, listingIds) {
  return requestJson(`/api/v1/automap/dealer-portal/dealers/${encodeURIComponent(dealerId)}/listings/bulk-confirm`, {
    method: "POST",
    body: JSON.stringify({ listingIds }),
  });
}
